import { Link } from "react-router-dom";

const COLUMNS = [
    {
        heading: "Legal",
        links: [
            { label: "Términos y condiciones", to: "/legal/terminos", testid: "footer-terms" },
            { label: "Política de privacidad", to: "/legal/privacidad", testid: "footer-privacy" },
            { label: "Política de cookies", to: "/legal/cookies", testid: "footer-cookies" },
            { label: "Juego responsable", to: "/legal/juego-responsable", testid: "footer-responsible" },
            { label: "Política AML / Antifraude", to: "/legal/antifraude", testid: "footer-antifraude" },
        ],
    },
    {
        heading: "Creadores",
        links: [
            { label: "Descubrir creadores", to: "/creadores", testid: "footer-creators-discover" },
            { label: "Pools destacados", to: "/explore?featured=1", testid: "footer-featured" },
            { label: "Aplicar al programa", to: "/creadores/aplicar", testid: "footer-creators-apply" },
            { label: "Términos para creadores", to: "/legal/terminos-creadores", testid: "footer-creators-terms" },
        ],
    },
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer"
            className="border-t border-p2w-line bg-p2w-bg mt-24"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
                <div className="flex items-center gap-2">
                    <div className="font-sora font-extrabold text-2xl">
                        Play2<span className="text-p2w-green">Win</span>
                    </div>
                </div>
                <p className="mt-3 text-sm text-p2w-gray max-w-xl leading-relaxed">
                    Plataforma social de predicciones basada en habilidad. MVP con puntos virtuales.
                </p>

                <div className="mt-10 grid gap-10 sm:grid-cols-2 sm:gap-12 max-w-2xl">
                    {COLUMNS.map((col) => (
                        <div key={col.heading}>
                            <h3
                                className="font-sora font-bold uppercase tracking-[0.18em] text-[#9AA0B5] text-xs"
                                data-testid={`footer-heading-${col.heading.toLowerCase()}`}
                            >
                                {col.heading}
                            </h3>
                            <ul className="mt-4 space-y-2.5">
                                {col.links.map((l) => (
                                    <li key={l.to}>
                                        <Link
                                            to={l.to}
                                            data-testid={l.testid}
                                            className="text-sm text-[#9AA0B5] hover:text-p2w-green transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p2w-green focus-visible:ring-offset-2 focus-visible:ring-offset-p2w-bg rounded-sm"
                                        >
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-12 pt-6 border-t border-p2w-line">
                    <div className="text-xs text-p2w-gray" data-testid="footer-copyright">
                        © {year} Play2Win. Todos los derechos reservados.
                    </div>
                </div>
            </div>
        </footer>
    );
}
